import { render, staticRenderFns } from "./FormPricing.vue?vue&type=template&id=441b2701&scoped=true&"
import script from "./FormPricing.vue?vue&type=script&lang=js&"
export * from "./FormPricing.vue?vue&type=script&lang=js&"
import style0 from "./FormPricing.vue?vue&type=style&index=0&id=441b2701&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441b2701",
  null
  
)

export default component.exports